import React from 'react'
import {
  Button,
  Container,
  Image,
  ListContainer,
  StepsProgress,
  State,
  TextBody,
  TextCaption,
  TextTitle
} from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const Card = ({
  translations,
  icon,
  amount,
  title,
  description,
  buttons,
  recurrence,
  steps,
  validated,
  isLoading,
  bg = Container.backgrounds.white
}) => {
  return (
    <Container
      display={Container.displays.flex}
      bg={bg}
      position={Container.positions.relative}
      rounded
      p="8">
      <Container
        width="2/5"
        pr="8"
        display={Container.displays.flex}
        alignItems={Container.alignItemsValues.center}
        flexDirection={Container.flexDirections.column}>
        <Container>
          <Image height="16" src={icon} />
        </Container>
        {amount ? (
          <Container pt="4">
            <TextTitle
              heading={TextTitle.headings.h3}
              alignment={TextTitle.alignments.center}
              data-testing="ProfilePoints_TextTitle_EarningQoins">
              {amount}
            </TextTitle>
            <TextBody
              alignment={TextBody.alignments.center}
              {...htmlTranslation(translations, 'tk_actionPoints')}
            />
          </Container>
        ) : null}
        {recurrence ? (
          <Container pt="4">
            <TextBody
              alignment={TextBody.alignments.center}
              size={TextBody.sizes.xs}
              breakWords
              data-testing="ProfilePoints_TextBody_EarningRecurrence">
              {recurrence}
            </TextBody>
          </Container>
        ) : null}
        {steps && steps.length > 0 ? (
          <Container pt="2">
            {steps.length < 6 ? (
              <StepsProgress
                steps={steps}
                size={StepsProgress.sizes.s}
                getStepText={() => ''}
                getStepContent={index => (
                  <TextBody darkMode size={TextBody.sizes.xxs}>
                    {index + 1}
                  </TextBody>
                )}
                isStepCompleted={index => steps[index]}
              />
            ) : (
              <TextCaption
                alignment={TextBody.alignments.center}
                size={TextCaption.sizes.xs}>
                {steps.filter(Boolean).length + ' / ' + steps.length}
              </TextCaption>
            )}
          </Container>
        ) : null}
      </Container>
      <Container
        width="3/5"
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.between}
        flexDirection={Container.flexDirections.column}>
        <Container>
          <TextCaption size={TextCaption.sizes.m}>{title}</TextCaption>
          <Container pt="4">
            <TextBody breakWords="false" acceptsHtml value={description} />
          </Container>
        </Container>
        {buttons && buttons.length > 0 ? (
          <Container>
            <Container
              display={Container.displays.flex}
              alignItems={Container.alignItemsValues.center}
              pt="4">
              <ListContainer
                xBetween="4"
                yBetween="4"
                alignItems={ListContainer.alignItemsValues.center}>
                {buttons.map((button, buttonIndex) => {
                  return (
                    <Button
                      key={buttonIndex}
                      disabled={isLoading}
                      {...button}
                    />
                  )
                })}
              </ListContainer>
            </Container>
          </Container>
        ) : null}
      </Container>
      {validated === true && (
        <>
          <Container
            position={Container.positions.absolute}
            t="0"
            r="0"
            b="0"
            l="0"
            bg={Container.backgrounds.secondary}
            opacity="50"
            zIndex="1"
            rounded
          />
          <Container
            position={Container.positions.absolute}
            r="3"
            b="3"
            zIndex="1">
            <State
              state={State.states.valid}
              size={State.sizes.l}
              data-testing="ProfilePoints_State_EarningValidated"
            />
          </Container>
        </>
      )}
    </Container>
  )
}
const QoinsActions = ({
  title,
  actions,
  disclaimerOne,
  disclaimerTwo,
  translations,
  isLoading,
  firstQoinsAction = false,
  lastQoinsAction = false,
  isEarnPoints = false
}) => {
  return (
    <Container
      fullWidth
      px={['4', '6']}
      py={firstQoinsAction ? '8' : '4'}
      bg={
        firstQoinsAction
          ? Container.backgrounds.turquoise
          : !lastQoinsAction && !isEarnPoints
          ? Container.backgrounds.hardWhite
          : isEarnPoints
          ? Container.backgrounds.white
          : ''
      }>
      <Container layout={Container.layouts.mid} pb={firstQoinsAction && '14'}>
        {disclaimerOne && (
          <Container pb="2">
            <TextBody
              size={TextCaption.sizes.m}
              alignment={TextTitle.alignments.center}
              acceptsHtml
              value={disclaimerOne}
            />
          </Container>
        )}
        {disclaimerTwo && (
          <Container pb="2">
            <TextBody
              size={TextCaption.sizes.s}
              alignment={TextTitle.alignments.center}
              acceptsHtml
              value={disclaimerTwo}
            />
          </Container>
        )}
        <Container
          pb={firstQoinsAction ? '10' : '8'}
          pt={firstQoinsAction ? '8' : '4'}>
          <TextTitle
            heading={TextTitle.headings.h3}
            alignment={!isEarnPoints && TextTitle.alignments.center}>
            {title}
          </TextTitle>
        </Container>
        <ListContainer fullWidth columns={[1, 1, 2]} xBetween="6" yBetween="6">
          {actions.map((item, itemIndex) => (
            <Card
              key={itemIndex}
              isLoading={isLoading}
              {...item}
              translations={translations}
              bg={
                isEarnPoints
                  ? Container.backgrounds.hardWhite
                  : Container.backgrounds.white
              }
            />
          ))}
        </ListContainer>
      </Container>
    </Container>
  )
}
const PointsEarningActions = ({
  translations,
  earningActions,
  earnedActions,
  videosActions,
  featureActions,
  isLoading,
  isEarnPoints,
  hideEarnedActions
}) => {
  return (
    <Container pb="14">
      <ListContainer columns={1}>
        {!isEarnPoints && featureActions && featureActions.length > 0 ? (
          <QoinsActions
            title={translations.tk_coinsFeature}
            disclaimerOne={translations.tk_coinsFeatureDisclaimerOne}
            disclaimerTwo={translations.tk_coinsFeatureDisclaimerTwo}
            actions={featureActions}
            translations={translations}
            isLoading={isLoading}
            firstQoinsAction
            isEarnPoints={isEarnPoints}
          />
        ) : null}
        {earningActions && earningActions.length > 0 ? (
          <QoinsActions
            title={translations.tk_coinsEarning}
            actions={earningActions}
            translations={translations}
            isLoading={isLoading}
            isEarnPoints={isEarnPoints}
          />
        ) : null}
        {!isEarnPoints && videosActions && videosActions.length > 0 ? (
          <QoinsActions
            title={translations.tk_videoFeature}
            actions={videosActions}
            translations={translations}
            isLoading={isLoading}
            isEarnPoints={isEarnPoints}
          />
        ) : null}
        {!hideEarnedActions && earnedActions && earnedActions.length > 0 ? (
          <QoinsActions
            title={translations.tk_coinsEarned}
            actions={earnedActions}
            translations={translations}
            isLoading={isLoading}
            lastQoinsAction
            isEarnPoints={isEarnPoints}
          />
        ) : null}
      </ListContainer>
    </Container>
  )
}
export default PointsEarningActions
